/**
 * ScrollToTop — al navegar a otra ruta, vuelve el scroll ARRIBA.
 *
 * En SPAs el scroll no se resetea solo al cambiar de página: quedás en la posición anterior (por eso
 * al entrar a una integración se veía la parte de abajo). Ojo: el admin NO scrollea en el `window` —
 * el contenedor con scroll es `#root` (`overflow-y:auto` en polaris.css) y, en móvil, `.sf-mobile-content`.
 *
 * Se resetea por PATHNAME (no por query params, para no saltar al cambiar un filtro de la misma página).
 * useLayoutEffect corre antes del paint → sin flash de "aparece abajo y salta arriba".
 */
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const root = document.getElementById('root');
    if (root) root.scrollTop = 0;
    const mobile = document.querySelector<HTMLElement>('.sf-mobile-content');
    if (mobile) mobile.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
